/*
 * Copyright 2022-2024. NXGN Management, LLC. All Rights Reserved.
 */

import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SearchComponent } from "./components/search/search.component";

import { httpInterceptorProviders } from "./http-inteceptors";

import { ToastrModule } from "ngx-toastr";
import { TemplateComponent } from "./components/template/template.component";
import { ProvisioningTemplateModule } from "./components/template/provisioning-template.module";
import { SecurityModule } from "./components/security/security.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MatTabsModule } from "@angular/material/tabs";
import { MerchantDetailsModule } from "./components/merchant-details/merchant-details.module";
import { LoadSpinnerModule } from "./components/load-spinner/load-spinner.module";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { DatePipe } from "@angular/common";
import { BsModalRef, ModalModule } from "ngx-bootstrap/modal";

@NgModule({
  declarations: [AppComponent, SearchComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      progressBar: true,
      closeButton: true,
      timeOut: 10000,
      extendedTimeOut: 5000,
      enableHtml: true,
      positionClass: "toast-top-full-width"
    }),
    ProvisioningTemplateModule,
    SecurityModule,
    FontAwesomeModule,
    MatTabsModule,
    MerchantDetailsModule,
    LoadSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ModalModule.forRoot()
  ],
  providers: [httpInterceptorProviders, DatePipe, BsModalRef],
  exports: [],
  bootstrap: [AppComponent, TemplateComponent]
})
export class AppModule {}
